export const LIMIT_ROOT = 'limits';
export const CUSTOM_REPORTS = 'custom-reports';
export const DASHBOARDS = 'dashboards';
export const STANDARD_REPORTS = 'standard-reports';
export const DASHBOARD_MAX_WIDGETS = 'dashboard-max-widgets';